require('url-change-event');

const axios = require('axios');
const {
  EVENT_TYPES,
  URL_ENDPOINTS,
  APP_METADATA,
  APP_SETTING,
  APP_BASE_URLS
} = require('../constants');

let app;

// setting up initial variables
let config = {
  // domain can be sent as config.
  // Used when request domain is different than applications client side domain
  appDomain: undefined,

  // function to modify the request url
  // to be used if the application requires the url to be modified before making the call
  getQueryParams: undefined,

  // flag to stop sending CSRF token as part of headers
  disableCSRFToken: false
};

function init(appName, options = {}) {
  app = appName;
  config = Object.assign(config, options);
}

function constructPageViewEvent(newURL, oldURL) {
  const { userAgent } = window.navigator;
  const { title } = window.document;

  const webPageEvent = {
    event_type: EVENT_TYPES.WebPageView,
    url: newURL ? newURL.href : null,
    host: newURL ? newURL.host : null,
    path: newURL ? newURL.pathname : null,
    origin: oldURL ? oldURL.href : null,
    title,
    user_agent: userAgent,
    app
  };
  return webPageEvent;
}

function getCsrfToken() {
  // nuxt apps
  const metacsrf = document.querySelector("meta[name='csrf-token']");
  if (metacsrf) {
    return metacsrf.getAttribute('content');
  }

  const cookie = Object.fromEntries(document.cookie.split('; ').map((v) => v.split('=').map(decodeURIComponent)));
  if (cookie['csrf-token']) {
    return cookie['csrf-token'];
  }
}

function postEventData(event) {
  const domain = window.location.origin;
  const url = `${domain}${APP_BASE_URLS[app]}${URL_ENDPOINTS.ServerAnalytics}`;
  axios.post(url, event, {
    headers: {
      'cambridgeone-app-version': APP_METADATA.AppVersion,
      'content-type': 'application/json',
      'csrf-token': getCsrfToken()
    }
  });
}

// function to add query params to the url
function addQueryParams(params, url = '') {
  if (params) {
    const qStr = Object.keys(params).reduce(((acc, key) => (acc.concat([key, params[key]].join('=')))), []).join('&');
    if (qStr) {
      if (url.indexOf('?') !== -1) {
        url = `${url}&${qStr}`;
      } else {
        url = `${url}?${qStr}`;
      }
    }
  }
  return url;
}

// function to send events array to backend
async function postEventsData(events) {
  const domain = config.appDomain || window.location.origin;
  let url = `${domain}${APP_BASE_URLS[app]}${URL_ENDPOINTS.ServerAnalyticsBulk}`;
  if (config.getQueryParams) {
    const queryParams = await config.getQueryParams();
    url = addQueryParams(queryParams, url);
  }
  const headers = {
    'cambridgeone-app-version': APP_METADATA.AppVersion,
    'content-type': 'application/json'
  };
  if (!config.disableCSRFToken) {
    headers['csrf-token'] = getCsrfToken();
  }

  return axios.post(url, events, {
    headers
  });
}

function capturePageViewEvents() {
  window.addEventListener('urlchangeevent', (eventData) => {
    if (eventData.action === 'beforeunload') {
      sessionStorage.setItem(APP_SETTING.SessionStorage.LastVisitedURL, window.location.href);
      return;
    }
    if (eventData.newURL) {
      if (eventData.oldURL && (eventData.oldURL.href !== eventData.newURL.href)) {
        const webPageEvent = constructPageViewEvent(eventData.newURL, eventData.oldURL);
        postEventData(webPageEvent);
      }
    }
  });
  window.addEventListener('load', () => {
    const lastVisitedURL = sessionStorage.getItem(APP_SETTING.SessionStorage.LastVisitedURL);
    const oldUrl = lastVisitedURL ? new URL(lastVisitedURL) : null;
    sessionStorage.removeItem(APP_SETTING.SessionStorage.LastVisitedURL);
    if (window.location.href) {
      const newUrl = new URL(window.location.href);
      const webPageEvent = constructPageViewEvent(newUrl, oldUrl);
      postEventData(webPageEvent);
    }
  });
}

function captureReportEvents(reportData) {
  reportData.event_type = EVENT_TYPES.Reporting;
  reportData.app = app;
  postEventData(reportData);
}
// function to sync array of local events to kafka
async function captureDesktopEvents(eventsData) {
  eventsData.forEach((eventData) => {
    eventData.command_name = EVENT_TYPES.Desktop;
  });
  const respone = await postEventsData(eventsData);
  return respone;
}

// function to sync array of web ereader events to kafka
async function captureEreaderEvents(eventsData) {
  eventsData.forEach((eventData) => {
    eventData.command_name = EVENT_TYPES.Ereader;
  });
  const respone = await postEventsData(eventsData);
  return respone;
}

// function to sync array of web ereader events to kafka
async function captureUserActionPerformedEvents(eventsData) {
  eventsData.forEach((eventData) => {
    eventData.command_name = EVENT_TYPES.UserActionPerformed;
  });
  const respone = await postEventsData(eventsData);
  return respone;
}

module.exports = {
  init,
  capturePageViewEvents,
  captureReportEvents,
  captureDesktopEvents,
  captureEreaderEvents,
  captureUserActionPerformedEvents
};
